import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import { ListItem } from '@unisporkal/alliance-ui';
import { InfoTooltip } from '../../molecules/InfoTooltip';
import { getCurrentAgreementRowText } from './agreementText';
import type { BatchAgreement } from './types';
import styles from './BatchAgreements.module.scss';

interface StaticAgreementRowProps {
  agreement: BatchAgreement;
  userHasMultiplePaAgreements: boolean;
  showOverageIndicator: boolean;
}

const StaticAgreementRow: React.FC<StaticAgreementRowProps> = ({
  agreement,
  userHasMultiplePaAgreements,
  showOverageIndicator,
}) => {
  const t = useTranslations();

  return (
    <ListItem
      className={styles.row}
      data-testid="agreement-details"
    >
      {getCurrentAgreementRowText(
        agreement,
        t,
        userHasMultiplePaAgreements,
        showOverageIndicator
      )}
      {showOverageIndicator && agreement.overageReached && (
        <InfoTooltip
          content={t('overage_tooltip')}
          tooltipClassName={styles.overageTooltip}
        />
      )}
    </ListItem>
  );
};

export default StaticAgreementRow;
